(function () {
  function initFaqTabs() {
    var containers = document.querySelectorAll('[data-faq-tabs-container]');
    containers.forEach(function (container) {
      var section = container.closest('[data-faq-with-tabs]');
      if (!section) return;
      var tabs = section.querySelectorAll('[data-faq-tab]');
      var panels = container.querySelectorAll('[data-faq-panel]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var id = tab.getAttribute('data-faq-tab');
          tabs.forEach(function (t) {
            t.classList.toggle('is-active', t === tab);
            t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
          });
          panels.forEach(function (panel) {
            panel.hidden = panel.getAttribute('data-faq-panel') !== id;
          });
        });
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFaqTabs);
  } else {
    initFaqTabs();
  }
})();
